module.exports = __webpack_public_path__ + "static/media/dcbank-feature-use.143b848a.svg";